import { ref } from 'vue';

// Global loading state for route transitions
const isRouteLoading = ref(false);
const loadingProgress = ref(0);

let progressInterval: number | null = null;

export function useRouteLoading() {
  const startLoading = () => {
    isRouteLoading.value = true;
    loadingProgress.value = 0;
    
    // Simulate progress bar (reaches 90% then waits for actual completion)
    if (progressInterval) clearInterval(progressInterval);
    
    progressInterval = window.setInterval(() => {
      if (loadingProgress.value < 90) {
        // Fast initial progress
        if (loadingProgress.value < 50) {
          loadingProgress.value += 10;
        } 
        // Slower progress as it approaches 90%
        else {
          loadingProgress.value += 5;
        }
      }
    }, 100);
  };

  const finishLoading = () => {
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
    
    // Complete the progress bar
    loadingProgress.value = 100;
    
    // Hide after animation completes
    setTimeout(() => {
      isRouteLoading.value = false;
      loadingProgress.value = 0;
    }, 300);
  };

  return {
    isRouteLoading,
    loadingProgress,
    startLoading,
    finishLoading,
  };
}
